export const apiListSupplier = "/1.0/wsm/supplier/list"
export const apiCreateSuplier = "/1.0/wsm/supplier/create"
export const apiUpdateSuplier = id => `/1.0/wsm/supplier/${id}/update`
export const apiDeleteSupplier = "/1.0/wsm/supplier/delete"
export const apiListContractSupplier = "/1.0/wsm/contract/supplier/list"
export const apiCreateContractSupplier = "/1.0/wsm/contract/supplier/create"

